import React, { useRef } from 'react'
import { AgTechButton, AgTechButtonProps, AgTechClickEventHandler } from './AgTechButtons'
import { AgTechSelectionProps, IAgTechSelectionItem } from '../Forms/Controls/Selection/AgTechCoreSelectionControlData'
import { AgTechSelectionPopUp } from '../Forms/Controls/Selection/AgTechSelectionPopUp'
import { AgTechPopUpPosition } from '@agtech/core/functions/AgTechAppPopUps'

export type AgTechSelectionButtonProps<TItem extends IAgTechSelectionItem> = AgTechButtonProps & {
    selectionProps: AgTechSelectionProps<TItem>
}

const AgTechSelectionButton = <TItem extends IAgTechSelectionItem>(props: AgTechSelectionButtonProps<TItem>) => {
    let buttonRef = useRef(null);

    return (
        <AgTechButton
            {...props}
            ref={buttonRef}
            action={async e => showSelectionPopUp(e, buttonRef, props.selectionProps)}
        />
    )
}

export const showSelectionPopUp = <TItem extends IAgTechSelectionItem>(
    e: AgTechClickEventHandler,
    callerRef: React.RefObject<any>,
    props: AgTechSelectionProps<TItem>
) => {
    e.popups.showPopUp({
        callerRef: callerRef,
        popup: () => (
            <AgTechSelectionPopUp
                selectionRef={callerRef}
                items={props.items}
                content={props.content}
                isOpen={true}
            />
        ),
        config: {
            position: AgTechPopUpPosition.BelowRight,
            fadeInTime: '200ms'
        }
    });
}
export default AgTechSelectionButton